import React from "react";
import { Link, useLocation } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";
import CashierModal from "@/components/Modals/CashierModals/CashierModal";
import { StyleAccountNavigation } from "./styles";

const links = [
  {
    to: "/account/profile",
    label: "계정",
    aliases: ["/my-page"],
  },
  {
    to: "/customer-service-center",
    label: "고객문의",
  },
];

const isActiveRoute = (pathname, item) =>
  pathname === item.to ||
  pathname.startsWith(`${item.to}/`) ||
  item.aliases?.some((alias) => pathname === alias || pathname.startsWith(`${alias}/`));

const AccountNavigation = () => {
  const { pathname } = useLocation();
  const { signOut } = useAuth();

  return (
    <StyleAccountNavigation>
      <nav aria-label="계정 메뉴">
        {links.map((item) => (
          <Link
            to={item.to}
            key={item.to}
            className={`account-nav-link ${isActiveRoute(pathname, item) ? "active" : ""}`}
          >
            {item.label}
          </Link>
        ))}

        <CashierModal button="지갑" triggerClassName="account-nav-link wallet" />

        <button type="button" className="account-nav-link logout" onClick={signOut}>
          로그아웃
        </button>
      </nav>
    </StyleAccountNavigation>
  );
};

export default AccountNavigation;
